export default "__VITE_ASSET__B_8wb7Rw__"